import { render, staticRenderFns } from "./ConversationMessage.vue?vue&type=template&id=2459863c&"
import script from "./ConversationMessage.vue?vue&type=script&lang=js&"
export * from "./ConversationMessage.vue?vue&type=script&lang=js&"
import style0 from "./ConversationMessage.vue?vue&type=style&index=0&id=2459863c&prod&lang=scss&scopped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports